import React from "react";

export function StatusBadge({ status }) {
  const map = {
    scheduled: { cls: "bg-sky-100 text-sky-800 border-sky-200", label: "Scheduled" },
    completed: { cls: "bg-emerald-100 text-emerald-800 border-emerald-200", label: "Completed" },
    skipped: { cls: "bg-stone-100 text-stone-700 border-stone-200", label: "Skipped" },
    no_access: { cls: "bg-rose-100 text-rose-800 border-rose-200", label: "No Access" },
    rescheduled: { cls: "bg-amber-100 text-amber-800 border-amber-200", label: "Rescheduled" },
    paid: { cls: "bg-emerald-100 text-emerald-800 border-emerald-200", label: "Paid" },
    sent: { cls: "bg-amber-100 text-amber-800 border-amber-200", label: "Sent" },
    pending: { cls: "bg-stone-100 text-stone-700 border-stone-200", label: "Pending" },
    overdue: { cls: "bg-rose-100 text-rose-800 border-rose-200", label: "Overdue" },
    unpaid: { cls: "bg-stone-100 text-stone-700 border-stone-200", label: "Unpaid" },
    paid_cash: { cls: "bg-emerald-100 text-emerald-800 border-emerald-200", label: "Paid (cash)" },
    paid_online: { cls: "bg-emerald-100 text-emerald-800 border-emerald-200", label: "Paid (online)" },
    invoice_sent: { cls: "bg-amber-100 text-amber-800 border-amber-200", label: "Invoice sent" },
    active: { cls: "bg-emerald-100 text-emerald-800 border-emerald-200", label: "Active" },
    trialing: { cls: "bg-sky-100 text-sky-800 border-sky-200", label: "Trial" },
    suspended: { cls: "bg-rose-100 text-rose-800 border-rose-200", label: "Suspended" },
  };
  const item = map[status] || { cls: "bg-muted text-foreground border-border", label: status || "—" };
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold border ${item.cls}`} data-testid={`status-${status}`}>
      {item.label}
    </span>
  );
}
